/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitTableListPathOrgUnitId, OrgUnitTableListStatus200 } from "../types/OrgUnitTableList.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgUnitTableList } from "../requests/orgUnitTableList.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgUnitTableListQueryKey = (org_unit_id?: MaybeRefOrGetter<OrgUnitTableListPathOrgUnitId>) =>
	[{ url: "/api/org_unit/:org_unit_id/table/", params: { org_unit_id: org_unit_id } }] as const;

export type OrgUnitTableListQueryKey = ReturnType<typeof orgUnitTableListQueryKey>;

export function orgUnitTableListQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgUnitTableListPathOrgUnitId>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgUnitTableListQueryKey(org_unit_id);
	return queryOptions<OrgUnitTableListStatus200, ResponseErrorConfig<Error>, OrgUnitTableListStatus200>({
		enabled: () => !!toValue(org_unit_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgUnitTableList(toValue(org_unit_id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @description Представление списка столов и залов точки организации.
 * {@link /api/org_unit/:org_unit_id/table/}
 */
export function useOrgUnitTableList<
	TData = OrgUnitTableListStatus200,
	TQueryData = OrgUnitTableListStatus200,
	TQueryKey extends QueryKey = OrgUnitTableListQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgUnitTableListPathOrgUnitId>,
	options: {
		query?: Partial<UseQueryOptions<OrgUnitTableListStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = (resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgUnitTableListQueryKey(org_unit_id);

	const query = useQuery(
		{
			...orgUnitTableListQueryOptions(org_unit_id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgUnitTableListStatus200, ResponseErrorConfig<Error>, TData, OrgUnitTableListStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
